import type { Theme } from "@mui/material/styles";
import "@mui/material/styles";
import themeTraining from "./brands/theme.training";
import themeWbsSchools from "./brands/theme.schools";
import themeWbsGroup from "./brands/theme.group";
import themeWbsAcademy from "./brands/theme.academy";
import type { Brand } from "../../lib/ChatbotConfig";

declare module "@mui/material/styles" {
  interface Palette {
    widgetStyles: {
      minimizedChatBubble: {
        backgroundColor: string;
        iconColor: string;
        hoverColor: string;
      };

      navbar: {
        backgroundColor: string;
        textColor: string;
        chevronColor: string;
        chevronHoverColor: string;
      };

      welcomePage: {
        backgroundColor: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      dataProtectionPage: {
        backgroundColor: string;
        headlineColor: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      button: {
        primary: {
          backgroundColor: string;
          textColor: string;
          hoverColor: string;
        };
        secondary: {
          backgroundColor: string;
          textColor: string;
          hoverColor: string;
        };
      };

      userChatBubble: {
        background: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      botChatBubble: {
        background: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      chatControls: {
        backgroundColor: string;
        iconColor: string;
        iconHoverColor: string;
      };
    };
  }

  interface PaletteOptions {
    widgetStyles?: {
      minimizedChatBubble: {
        backgroundColor: string;
        iconColor: string;
        hoverColor: string;
      };

      navbar: {
        backgroundColor: string;
        textColor: string;
        chevronColor: string;
        chevronHoverColor: string;
      };

      welcomePage: {
        backgroundColor: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      dataProtectionPage: {
        backgroundColor: string;
        headlineColor: string;
        textColor: string;
        linkColor: string;
        linkHoverColor: string;
      };

      button: {
        primary: {
          backgroundColor: string;
          textColor: string;
          hoverColor: string;
        };
        secondary: {
          backgroundColor: string;
          textColor: string;
          hoverColor: string;
        };
      };
      user: {
        background?: string;
        textColor?: string;
        linkColor?: string;
        linkHoverColor?: string;
      };
      bot: {
        background?: string;
        textColor?: string;
        linkColor?: string;
        linkHoverColor?: string;
      };

      chatControls: {
        backgroundColor: string;
        iconColor: string;
        iconHoverColor: string;
      };
    };
  }
}

export const getTheme = (brand: Brand): Theme => {
  switch (brand) {
    case "schools":
      return themeWbsSchools;
    case "group":
      return themeWbsGroup;
    case "academy":
      return themeWbsAcademy;
    case "training":
    default:
      return themeTraining;
  }
};
